"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const User_1 = __importDefault(require("../Notary/User"));
const Subscription_1 = __importDefault(require("./Subscription"));
class Seat extends Resource_1.default {
}
exports.default = Seat;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Seat.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", User_1.default)
], Seat.prototype, "user", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Subscription_1.default),
    __metadata("design:type", Subscription_1.default)
], Seat.prototype, "subscription", void 0);
